export default "__VITE_ASSET__DXyo4ePH__"